import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { theme } from '@/modules/common/theme';
import { FlowEndDetails, getPaletteByLoadHandling } from '../helpers';

const OPACITY = 0.3;
const MIXED_CHIP_SX = { color: 'text.secondary', fontWeight: 500 };

/** @description One end of a flow: the area or flow stop, colored by its load handling */
function FlowEndComponent({ name, loadHandlingType }: FlowEndDetails) {
  const { t } = useTranslation();

  if (name === null && loadHandlingType === undefined) {
    return <Chip label={t('common:mixed')} sx={MIXED_CHIP_SX} />;
  }

  const color = getPaletteByLoadHandling(loadHandlingType);

  return (
    <Chip
      label={name ?? t('common:mixed')}
      sx={{
        backgroundColor: alpha(color, OPACITY),
        color: theme.palette.getContrastText(color),
        fontWeight: 500,
      }}
    />
  );
}

export const FlowEnd = memo(FlowEndComponent);
